module.exports = __webpack_public_path__ + "static/media/icon-piece7-7.dc4d980e.png";